/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Pipe, PipeTransform} from "@angular/core";
import {AuthLevel} from "../../../../../types/aig/universe";

@Pipe({
	name: "aig_authcolor",
})

/**
 * Authレベルカラー
 *
 * @since 0.01
 */
export class AigAuthcolorPipe implements PipeTransform {

	/**
	 *
	 * @param value
	 * @param args
	 */
	public transform(value: any, args?: any): string {
		let result: string = "#287328";     // public
		if (value <= AuthLevel.system) {
			result = "#c41562";     // system
		} else if (value <= AuthLevel.manager) {
			result = "#4a5cae";     // manager
		} else if (value <= AuthLevel.company) {
			result = "#088f02";     // company
		} else if (value <= AuthLevel.studio) {
			result = "#b912ab";     // studio
		} else if (value <= AuthLevel.trainer) {
			result = "#00c3ff";     // trainer
		} else if (value <= AuthLevel.user) {
			result = "#8d7504";     // user
		}
		return result;
	}

}
